import { addDays, addMonths, format, parse } from "date-fns";
import { isNumber } from "lodash";

import { DateFormat } from "constants/date";
import { ReportDistribution } from "constants/reports/distribution";
import { IChartSeries } from "store/views/reports";
import { KeyMap } from "utils/interface";

import { getUniqueDateRanges } from "./utils";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getHoursData(series: IChartSeries[], labels: string[]): any[] {
  return series.map((singleSeries: IChartSeries) => {
    const dateData: KeyMap<string | number> = {};
    let rowTotal = 0;

    const dateFrom = singleSeries.filters && singleSeries.filters.dateFrom;
    const dateTo = singleSeries.filters && singleSeries.filters.dateTo;
    const customAggregate = singleSeries.extras && singleSeries.extras.customAggregate;

    for (let i = 0; i < labels.length; i += 1) {
      const value = singleSeries.data[i];
      const label = `${labels[i]}_${dateFrom}_${dateTo}`;
      dateData[label] = isNumber(value) ? value : "-";
      rowTotal += isNumber(value) ? value : 0;
    }

    return {
      ...singleSeries.filters,
      ...dateData,
      name: singleSeries.name,
      total: rowTotal,
      customAggregate,
      breakdownCustomElement: singleSeries?.extras?.breakdownCustomElement,
    };
  });
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getDateRangeData(series: IChartSeries[], distribution: ReportDistribution): any[] {
  const uniqueSeries = getUniqueDateRanges(series);
  const dateLongestPeriod = Math.max(...series.map((singleSeries: IChartSeries) => singleSeries.data.length));

  const addPeriodFnc = distribution === ReportDistribution.Day ? addDays : addMonths;

  return series.map((singleSeries: IChartSeries) => {
    const dateData: KeyMap<number | string> = {};
    const dateFrom = singleSeries.filters && singleSeries.filters.dateFrom;
    const dateTo = singleSeries.filters && singleSeries.filters.dateTo;
    if (!dateFrom || !dateTo) {
      return;
    }
    const customAggregate = singleSeries.extras && singleSeries.extras.customAggregate;

    const dateRangeSeriesIndex = uniqueSeries.findIndex(s => s === `${dateFrom}_${dateTo}`);

    let rowTotal = 0;

    for (let i = 0; i < dateLongestPeriod; i += 1) {
      const date = addPeriodFnc(dateFrom, i);
      const value = singleSeries.data[i];

      if (parse(dateTo) >= date) {
        const formattedDate = format(date, DateFormat.HtmlInputDate);
        dateData[`${formattedDate}_${dateRangeSeriesIndex}`] = isNumber(value) ? value : "-";
      }

      rowTotal += isNumber(value) ? value : 0;
    }

    return {
      ...singleSeries.filters,
      ...dateData,
      name: singleSeries.name,
      total: rowTotal,
      customAggregate,
      breakdownCustomElement: singleSeries?.extras?.breakdownCustomElement,
    };
  });
}
